const comments = [
  {
    avatar: '吃',
    name: '资深吃瓜人',
    time: '2小时前',
    content: '这个网站更新速度真的太快了，很多爆料都是这里首发才在其他平台看到的。作为老用户，每天必刷！',
    tag: '老用户',
  },
  {
    avatar: '瓜',
    name: '八卦探测器',
    time: '5小时前',
    content: '深度追踪那个栏目做得特别好，不光是爆表面料，还会深挖背景和资本关系，吃瓜吃得明明白白。',
    tag: '深度粉',
  },
  {
    avatar: '众',
    name: '路过的吃瓜群众',
    time: '1天前',
    content: '朋友推荐来的，本来以为就是个普通的八卦站，结果一刷就停不下来。内容分类清楚，找自己想看的瓜特别方便。',
    tag: '新用户',
  },
  {
    avatar: '爆',
    name: '真相挖掘机',
    time: '2天前',
    content: '投稿通道真的有用！之前投了一条线报，当天就被采用了。这种和用户互动的模式在八卦圈子里很难得。',
    tag: '爆料达人',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          瓜友热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          听听吃瓜群众们怎么说
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center font-heading text-lg flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
                <span className="ml-auto px-2 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-medium rounded whitespace-nowrap flex-shrink-0">
                  {item.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{item.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}